/** View States */
export const CARD_VIEW = 'cardView';
export const NO_VIEW_SWITCH = 'NO_VIEW_SWITCH';
export const TABLE_VIEW = 'tableView';

/* Filter Dropdown States */
export const VIEW_FILTER_OPEN = 'VIEW_FILTER_OPEN';
export const SORT_FILTER_OPEN = 'SORT_FILTER_OPEN';
export const DROP_DOWN_CLOSED = 'FILTERS_CLOSED';

/* Default filter/sort labels and IDs */
export const RELEVANCE_SORT_LABEL = 'Relevance';
export const NO_SORT_LABEL = 'Default';
export const DEFAULT_VIEW_FILTER_ID = 'LL_ALLPASS_VIEW_FILTER';
export const RELEVANCE_SORT_ID = 'LL_RELEVANCE_SORT_FILTER';
export const NO_SORT_ID = 'LL_NO_SORT_FILTER';
